import { z } from 'zod';

import { CursorPaginationMetaSchema, PaginationSchema } from '../../pagination.js';

import { CustomerRoleStatusSchema } from './customer-role.schemas.js';
import { PartyPersonTypeSchema, PartyResponseSchema } from './party.schemas.js';

export const PartyListSortFieldSchema = z.enum(['name', 'document', 'personType', 'status']);
export type PartyListSortField = z.infer<typeof PartyListSortFieldSchema>;

export const PartyListSortOrderSchema = z.enum(['asc', 'desc']);
export type PartyListSortOrder = z.infer<typeof PartyListSortOrderSchema>;

export const ListPartiesQuerySchema = PaginationSchema.extend({
  q: z.preprocess(
    (val) => (typeof val === 'string' && val.trim() === '' ? undefined : val),
    z.string().trim().min(1).max(100).optional(),
  ),
  personType: PartyPersonTypeSchema.optional(),
  status: CustomerRoleStatusSchema.optional(),
  sort: PartyListSortFieldSchema.optional(),
  order: PartyListSortOrderSchema.optional(),
});

export type ListPartiesQuery = z.infer<typeof ListPartiesQuerySchema>;

export const PartyListItemSchema = PartyResponseSchema.extend({
  roleStatus: CustomerRoleStatusSchema,
});
export type PartyListItem = z.infer<typeof PartyListItemSchema>;

export const ListPartiesResponseSchema = z.object({
  items: z.array(PartyListItemSchema),
  pagination: CursorPaginationMetaSchema,
});

export type ListPartiesResponse = z.infer<typeof ListPartiesResponseSchema>;
